import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import Footer from "../../components/Footer";
import Navbar from "../../components/Navbar";
import Introduction from "../../components/Introduction";
import useFetch from "../../hooks/useFetch";
import config from "../../config";
import DefaultPage from "../DefaultPage/DefaultPage";
import "./GallerySubPage.css";
import { useState } from "react";
import { useParams } from "react-router-dom";
import { BlocksRenderer } from "@strapi/blocks-react-renderer";
import {
  Download,
  Fullscreen,
  Thumbnails,
  Video,
} from "yet-another-react-lightbox/plugins";
import "yet-another-react-lightbox/plugins/thumbnails.css";
import Loader from "../../components/Loader";

const GallerySubPage = () => {
  // index pro sledovani lightboxu
  const [index, setIndex] = useState(-1);

  let month = "0";
  let day = "0";
  let year = "0";

  // parametry ktere dostavame z url adresy (id)
  const params = useParams();
  const { id } = params;

  //fetch medii(galerii)
  const { loading, error, data } = useFetch(
    `${config.api}/api/galeries/${id}?populate=*`
  );

  if (loading) return <Loader />;
  if (error) return <DefaultPage message="Chyba při načítání galerie" />;

  if (!data || !data.data) return <DefaultPage message="Žádné fotografie" />;

  //? test
  //? console.log(data.data);

  //vytvoreni noveho pole pro media z duvodu, ze lightbox potrebuje jiny format JSONU nez jaky dostaneme ze strapi
  //kontrola zdali jsou tam data - jelikoz pole medii je nepovinne
  const galleryData = data?.data?.files ?? [];
  const mediaEdited = [];

  for (let i = 0; i < galleryData.length; i++) {
    const item = galleryData[i];
    // kontrola nejdulezitejsich hodnot kdyby nahodou byl null
    const mime = item?.mime ?? "";
    const url = item?.url ?? "";
    const mediumUrl = item?.formats?.medium?.url ?? "";
    if (mime.startsWith("image")) {
      mediaEdited.push({
        id: item.id,
        type: "image",
        alternativeText: item.alternativeText,
        src: `${config.api}${url}`,
        medium: `${config.api}${mediumUrl}`,
      });
    } else if (mime.startsWith("video")) {
      mediaEdited.push({
        id: item.id,
        type: "video",
        alternativeText: item.alternativeText,
        title: item.title || "Video Title",
        description: item.description || "Video Description",
        width: 1280, // Adjust as needed
        height: 720, // Adjust as needed
        poster: `/images/video-icon.png`, // default poster
        sources: [
          {
            src: `${config.api}${url}`,
            type: mime,
          },
        ],
      });
    }
  }

  // uprava datumu
  if (data?.data?.date) {
    const date = new Date(data?.data?.date);
    month = date.toLocaleString("default", { month: "long" });
    day = date.getDate();
    year = date.getFullYear();
  }

  //? test
  //? console.log(mediaEdited);
  //? console.log(data);
  //? console.log(mediaEdited[0].src);

  //změna titulku stránky v prohlížeči
  document.title = "Fotogalerie";

  return (
    <div>
      <Navbar />
      <Introduction title="GALERIE" text="" image={data?.data?.files[0].url} />
      <div className="container-fluid background-white">
        <div className="container container-background p-4 p-md-5">
          <h1>{data.data.name}</h1>
          <h3>
            {day}. {month} {year}
          </h3>
          {/* kontrola jestli je text array a jestli neni null */}
          <BlocksRenderer
            content={
              Array.isArray(data?.data?.description)
                ? data.data.description
                : []
            }
            blocks={{
              image: ({ image }) => (
                <img
                  src={image.url}
                  alt={image.alternativeText}
                  className="blocks-renderer-img"
                />
              ),
              list: ({ children, format }) =>
                format === "unordered" ? (
                  <ul className="blocks-renderer-ul">{children}</ul>
                ) : (
                  <ol className="blocks-renderer-ol">{children}</ol>
                ),
            }}
          ></BlocksRenderer>
          <Lightbox
            plugins={[Download, Fullscreen, Thumbnails, Video]}
            open={index >= 0}
            close={() => setIndex(-1)}
            index={index}
            slides={mediaEdited}
          />

          {/* vykreslovani medii podle toho jestli to je video nebo obrazek, na videu nastaven defaultni nahled */}
          <div className="container d-flex flex-wrap justify-content-center">
            {mediaEdited.map((media, index) => (
              <div
                key={index}
                className="m-2 col-10 col-md-3 d-flex justify-content-center"
              >
                {media.type === "image" ? (
                  <img
                    src={media.src}
                    onClick={() => setIndex(index)}
                    alt={media.alternativeText}
                    className="media-thumbnail media-gallery"
                    style={{ cursor: "pointer" }}
                  />
                ) : (
                  <img
                    src="/images/video-icon.png"
                    onClick={() => setIndex(index)}
                    alt={media.alternativeText}
                    className="media-thumbnail media-gallery"
                    style={{ cursor: "pointer" }}
                  />
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};
export default GallerySubPage;

